import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { HelmetProvider } from 'react-helmet-async';
import GlobalStyle from './styles/globalStyles';
import theme from './styles/theme';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import NotFoundPage from './pages/NotFoundPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import ContactPage from './pages/ContactPage';
import RequestQuotePage from './pages/RequestQuotePage';
import IndustriesPage from './pages/IndustriesPage';
import AboutUsPage from './pages/AboutUsPage';
import ScrollToTop from './components/utils/ScrollToTop';
import { QuoteProvider } from './contexts/QuoteContext';

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <QuoteProvider>
        <ThemeProvider theme={theme}>
          <GlobalStyle theme={theme} />
          <Router>
            <ScrollToTop />
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/industries" element={<IndustriesPage />} />
                <Route path="/about" element={<AboutUsPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/request-quote" element={<RequestQuotePage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms-of-service" element={<TermsOfServicePage />} />
                {/* Add more routes here as needed */}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Layout>
          </Router>
        </ThemeProvider>
      </QuoteProvider>
    </HelmetProvider>
  );
};

export default App;
